import * as React from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'

type JumpModalProps = {
  onJump: (index: number) => void
  maxIndex: number
  open: boolean
  onClose: () => void
  currentIndex?: number
}

export function JumpModal({ onJump, maxIndex, open, onClose, currentIndex }: JumpModalProps) {
  const [index, setIndex] = React.useState(currentIndex || 0)

  const handleIndexChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value) || 0
    setIndex(Math.max(0, Math.min(value, maxIndex)))
  }

  const adjustIndex = (amount: number) => {
    setIndex((prev) => Math.max(0, Math.min(prev + amount, maxIndex)))
  }

  const handleJump = () => {
    onJump(index)
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Jump to Index</DialogTitle>
          <DialogDescription>Enter a video index number to jump to that position</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" onClick={() => adjustIndex(-10)}>
              -10
            </Button>
            <Input
              type="number"
              value={index}
              onChange={handleIndexChange}
              min={0}
              max={maxIndex}
              className="text-center"
            />
            <Button variant="outline" size="icon" onClick={() => adjustIndex(10)}>
              +10
            </Button>
          </div>
          <div className="text-sm text-muted-foreground text-center">Maximum index: {maxIndex}</div>
        </div>
        <DialogFooter>
          <Button onClick={handleJump}>Jump</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
